/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class CompanyService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'CompanyService\' loaded');
    }
}

export { CompanyService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/CompanyService.js